module.exports = __webpack_public_path__ + "static/img/404.e0c61bf5.png";